var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.023 8.63597L25.038 12.31L27.728 15L25.039 17.689L26.023 21.364L22.348 22.348L21.364 26.023L17.69 25.038L15 27.728L12.31 25.038L8.63597 26.023L7.65197 22.348L3.97697 21.364L4.96197 17.69L2.27197 15L4.96197 12.31L3.97697 8.63597L7.65197 7.65097L8.63597 3.97697L12.311 4.96097L15 2.27197L17.689 4.96097L21.364 3.97697L22.348 7.65097L26.023 8.63597Z",
    className: "iconStar",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L14 19L21 12",
    className: "iconOrange",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI2LjAyMyA4LjYzNTk3TDI1LjAzOCAxMi4zMUwyNy43MjggMTVMMjUuMDM5IDE3LjY4OUwyNi4wMjMgMjEuMzY0TDIyLjM0OCAyMi4zNDhMMjEuMzY0IDI2LjAyM0wxNy42OSAyNS4wMzhMMTUgMjcuNzI4TDEyLjMxIDI1LjAzOEw4LjYzNTk3IDI2LjAyM0w3LjY1MTk3IDIyLjM0OEwzLjk3Njk3IDIxLjM2NEw0Ljk2MTk3IDE3LjY5TDIuMjcxOTcgMTVMNC45NjE5NyAxMi4zMUwzLjk3Njk3IDguNjM1OTdMNy42NTE5NyA3LjY1MDk3TDguNjM1OTcgMy45NzY5N0wxMi4zMTEgNC45NjA5N0wxNSAyLjI3MTk3TDE3LjY4OSA0Ljk2MDk3TDIxLjM2NCAzLjk3Njk3TDIyLjM0OCA3LjY1MDk3TDI2LjAyMyA4LjYzNTk3WiIgY2xhc3M9Imljb25TdGFyIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KICA8cGF0aCBkPSJNMTAgMTVMMTQgMTlMMjEgMTIiIGNsYXNzPSJpY29uT3JhbmdlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };